import React from 'react'
import { Heading, GContainer, Seachbar, Input, CustomBsSearch, ToggleMenu } from '../../style/MobileNav'
import { CustomDiv } from '../../style/shared'
import { SettingIcon } from '../../style/Home'
import Setting from "../../assets/Pmc/setting.svg";
import { Grid } from '@material-ui/core';
import { Logo1, Logo2 } from '../logo/Logo';
import { Sidebar } from "./Sidebar";
import Cal from "../../assets/sidebar/calendar.svg";
import User from "../../assets/sidebar/user.svg";
import Menu from "../../assets/sidebar/menu.svg";
import Person from "../../assets/sidebar/person.svg";
import CalA from "../../assets/sidebar/calendarA.svg";
import UserA from "../../assets/sidebar/userA.svg";
import MenuA from "../../assets/sidebar/menuA.svg";
import PersonA from "../../assets/sidebar/personA.svg";
import { useState } from 'react';
import './MobileNav.css';
import CustomizePopup from "../Home/CustomizePopup";

export const sidebarConfig = [
    {
        path: "/Calender",
        icon: Cal,
        activeIcon: CalA,
        alt: "Cal",
    },
    {
        path: "/People/dashboard",
        icon: User,
        activeIcon: UserA,
        alt: "User",
    },
    {
        path: "",
        icon: Menu,
        activeIcon: MenuA,
        alt: "Menu",
    },
    {
        path: "",
        icon: Person,
        activeIcon: PersonA,
        alt: "Person",
    },
];

const MobileNavbar = (props) => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [setState, isSetState] = useState(false);
    const currentUrl = window.location.href;
    const handleToggleMenuClick = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    const handleSettingClick = () => {
        isSetState(true);
    };

    const handleClosePopup = () => {
        isSetState(false);
    };
    return (
        <>
            <GContainer >
                <Grid container className='headerContent'>
                    <Grid item md={6} xs={4}>
                        <Logo2 className="logoMobile" />
                    </Grid>
                    <Grid item md={6} xs={8}>
                        <Grid container>
                            <Grid item xs={9}>
                                <div style={{ textAlign: "right" }} className='settingIcon'>
                                    <SettingIcon src={Setting} alt="setting" onClick={handleSettingClick} style={{ width: "30px" }} />
                                </div>
                            </Grid>
                            <Grid item xs={3} className='text-right noToggle'>
                                <ToggleMenu className={`text-right ${isSidebarOpen ? "activeToggle" : ""}`} onClick={handleToggleMenuClick}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </ToggleMenu>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {isSidebarOpen &&
                    <div className="mobSideBar" onClick={handleToggleMenuClick}>
                        <Sidebar config={sidebarConfig} />
                        <div className='afterEffect' />
                    </div>
                }
                {setState && <CustomizePopup open={isSetState} onClose={handleClosePopup} />}
            </GContainer >
            <GContainer style={{ marginTop: "90px", marginBottom: "30px" }} className='calenderNoMarg'>
                <Grid container >
                    <Grid item md={12} xs={12}>
                        <Grid container className='responsiveClass' style={{ alignItems: "baseline" }}>
                            <Grid item md={2} sm={2} lg={2} xs={12} className='mobileCss mobCenter'>
                                <Heading>
                                    {
                                    currentUrl.includes('Calender')
                                    ? 
                                    "Calender" : "Patient chart"
                                    }
                                </Heading>
                            </Grid>
                            <Grid item md={6} sm={7} lg={8} xs={12} className='mobileCss mobCenter  mobP-LR'>

                                <Seachbar>
                                    <CustomBsSearch />
                                    <Input placeholder="Search" />
                                </Seachbar>
                            </Grid>
                            <Grid item md={4} sm={3} lg={2} xs={12} className='mobileCss mobCenter'>
                                <div className='w6-text-center' style={{ fontSize: "16px", marginTop: "20px", textAlign: "right", paddingRight: "12px", fontWeight: 600, fontFamily: 'Montserrat SemiBold,"Open Sans",Helvetica,Arial,sans-serif !important' }}>Provider: TOM COLLINS</div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </GContainer >
        </>
    )
}

export default MobileNavbar
